import { useEventSafetyRating } from '@shared/hooks/useEventSafetyRating';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useToast } from '@withjoy/joykit';

type UseEventSafetyRatingQueryArgs = {
  eventHandle: Maybe<string>;
};

export const useVerifyEventSafetyAndSendMessage = (args: UseEventSafetyRatingQueryArgs) => {
  const { eventHandle } = args;
  const { toast } = useToast();
  const { isUnsafe, isLoading: isFetchingEventSafetyRating } = useEventSafetyRating({ eventHandle });

  const verifyEventSafetyAndSendMessage = useEventCallback((onSuccess: () => void, onFail?: () => void) => {
    if (isFetchingEventSafetyRating) {
      return;
    }

    if (isUnsafe) {
      onFail?.();
      toast(`Error: Unable to send messages. Verify your account with support@withjoy.com or via the help chat.`);
      return;
    }

    onSuccess();
  });

  return {
    isFetchingEventSafetyRating,
    verifyEventSafetyAndSendMessage,
  };
};
